import type { Except } from "type-fest";
import { z } from "zod";
import type { ProviderId} from "../provider-id";
import { providerIdZodSchema } from "../provider-id";

type ProviderUnpauseCommand = {
    _type: "PROVIDER_UNPAUSE_COMMAND";
    providerId: ProviderId;
};

const providerUnpauseCommandZodSchema: z.ZodSchema<ProviderUnpauseCommand> =
    z.object({
        _type: z.literal("PROVIDER_UNPAUSE_COMMAND"),
        providerId: providerIdZodSchema,
    });

const providerUnpauseCommandFactory = (
    params: Except<ProviderUnpauseCommand, "_type">,
): ProviderUnpauseCommand => {
    return {
        ...params,
        _type: "PROVIDER_UNPAUSE_COMMAND",
    };
};
export { providerUnpauseCommandFactory, providerUnpauseCommandZodSchema };
export type { ProviderUnpauseCommand };
